var BxfFormValidationType;
(function (BxfFormValidationType) {
    BxfFormValidationType["ERROR"] = "error";
    BxfFormValidationType["WARNING"] = "warning";
})(BxfFormValidationType || (BxfFormValidationType = {}));

export { BxfFormValidationType as B };
